// src/components/UserProfileHeader/UserProfileHeader.tsx

import moment from "moment";
import React, { memo } from "react";
import grayZobu from "../../../../../../assets/media/gray-zobu.svg";

interface UserProfile {
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  mobile?: string;
  time_create?: string;
}

interface UserProfileHeaderProps {
  profile: UserProfile | null;
}

const UserProfileHeader: React.FC<UserProfileHeaderProps> = memo(
  ({ profile }) => {
    const formatDate = (isoDate?: string): string => {
      if (!isoDate) return "";
      return moment(isoDate).format("MMM YYYY");
    };

    return (
      <div className="flex flex-shrink-0 p-4 sm:p-0">
        <a href="/" className="flex-shrink-0 block w-full group">
          <div className="flex items-center">
            <div>
              <img
                className="inline-block w-20 h-20 bg-gray-200 rounded-full sm:w-10 sm:h-10"
                src={grayZobu}
                alt="profile"
              />
            </div>
            {profile && (
              <div className="ml-6">
                <div className="text-lg font-medium sm:text-sm">
                  {`${profile.first_name || ""} ${
                    profile.middle_name ? profile.middle_name + " " : ""
                  }${profile.last_name || ""}`}
                </div>
                <div className="text-sm text-gray-600">{profile.mobile}</div>
                <div className="text-sm text-gray-600">
                  Zosteler since {formatDate(profile.time_create)}
                </div>
              </div>
            )}
          </div>
        </a>
      </div>
    );
  }
);

export default UserProfileHeader;
